<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { USER_REQUEST } from "actions/user";

export default {
  created: function() {
    if (this.$store.getters.isAuthenticated) {
        this.$store.dispatch(USER_REQUEST);
    }
  }
}
</script>
